export default "__VITE_ASSET__0a12ac26__"